import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { HoofdleidingProject } from '../../types/HoofdleidingProject'

interface Props {
  project: HoofdleidingProject
  handleClose: () => void
}

export const Verantwoordelijke = ({ project, handleClose }: Props) => {
  const { mutate: saveEvent } = useSaveEvent()

  const verantwoordelijke = project.verantwoordelijken.includes(project.combi)
    ? project.netbeheerders[0]
    : project.combi

  const handleSubmitClick = () => {
    saveEvent(
      {
        id: project.aanvraagID,
        data: {
          verantwoordelijke,
        },
        type: 'hoofdleiding_verantwoordelijke',
        source: 'manual',
      },
      {
        onSuccess: () => handleClose(),
      },
    )
  }

  return (
    <>
      <DialogTitle>Wijzigen verantwoordelijke</DialogTitle>
      <DialogContent>
        {`Wilt u de verantwoordelijke van dit project wijzigen naar ${verantwoordelijke}?`}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button color="primary" onClick={handleSubmitClick}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
